export default "__VITE_ASSET__DdfvdyV8__"